<template>
        
    <div class="card">
        <div class="card-body row">

            <div class="col-3"></div>
            <div class="col-6 row">
                <div class="form-group col-6">
                    <label 
                        for="input6" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('app.month') }} 
                    </label>
                    <select 
                        class="form-control"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="row.month"
                        @change="changeMonth()">
                        <option value="1">{{ $t('app.january') }}</option>
                        <option value="2">{{ $t('app.february') }}</option>
                        <option value="3">{{ $t('app.march') }}</option>
                        <option value="4">{{ $t('app.april') }}</option>
                        <option value="5">{{ $t('app.may') }}</option>
                        <option value="6">{{ $t('app.june') }}</option>
                        <option value="7">{{ $t('app.july') }}</option>
                        <option value="8">{{ $t('app.august') }}</option>
                        <option value="9">{{ $t('app.september') }}</option>
                        <option value="10">{{ $t('app.october') }}</option>
                        <option value="11">{{ $t('app.november') }}</option>
                        <option value="12">{{ $t('app.december') }}</option>
                    </select>
                </div>
                <div class="form-group col-6">
                    <label 
                        for="input6" 
                        class="col-form-label"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                        {{ $t('app.year') }} 
                    </label>
                    <select 
                        class="form-control"
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        v-model="row.year">
                        <option v-for="i in 10" :key="i">
                            {{ row.startYear+i }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-3"></div>
            <br/>

            <div class="col-12">
                <div class="row" style="padding:20px">
                    <!-- <div class="col-1.5" 
                        v-for="(day, index) in row.daysWeek"
                        :key="day" 
                        :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                        style="width: 14%;background: black;color: white;height: 50px;border:1px solid #eff2f7;text-align: center;vertical-align: middle;padding:15px">
                        {{ day }}
                    </div> -->
                    <div class="col-1.5" 
                        v-for="i in row.daysInMonth" 
                        :key="i"
                        :class="(
                            new Date(row.year, row.month, i).toLocaleString('en-us', {weekday:'long'}) 
                            == 'Friday' || 
                            new Date(row.year, row.month, i).toLocaleString('en-us', {weekday:'long'}) 
                            == 'Saturday') 
                                ? 'div-disabled' : ''"
                        style="width: 14%;height: 120px;border:1px solid #eff2f7;text-align: center;vertical-align: middle;padding: 15px;">

                        <p class=""> 
                            <b>
                                {{ new Date(row.year, row.month, i).toLocaleString('en-us', {weekday:'long'}) }}
                            </b> 
                        </p>

                        <p style="margin-top: -10px">
                            {{ i }} / {{ row.month }}
                        </p>
                        
                        <div  v-if="
                            new Date(row.year, row.month, i).toLocaleString('en-us', {weekday:'long'}) 
                            != 'Friday' &&
                            new Date(row.year, row.month, i).toLocaleString('en-us', {weekday:'long'}) 
                            != 'Saturday'"
                            style="margin-top: -10px"
                            :class="[
                            // (fetchDay(i)['key'] == 2) ? 'btn-danger' :(fetchDay(i)['key'] == 1) ? 'btn-success' : 'btn-secondary', ($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''
                            ]">
                            <div 
                                v-for="(fetch, idx) in fetchDay(i)" 
                                :key="idx"
                                class="btn btn-secondary btn-rounded btn-sm">
                                {{ fetch }} {{ fetch }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'EmployeeSheet',
    props: [
        'employee',
    ],
    data(){
        return {
            // auth
            auth: {
                access_token: '',
            },
            row: {
                employee: this.$props.employee,
                currentYear: new Date().getFullYear(),
                currentMonth: new Date().getMonth(),
                daysInMonth: new Date(new Date().getFullYear(), new Date().getMonth(), 0).getDate(),
                startYear: 2021,
                month: new Date().getMonth()+1,
                year: new Date().getFullYear(),
                monthNames: ["January", "February", "March", "April", "May", "June",
                  "July", "August", "September", "October", "November", "December"
                ],
                ignoreDays: ['Friday', 'Saturaday'],
                months: [
                    { month: 'January', days: 31 },
                    { month: 'February', days: 28 },
                    { month: 'March', days: 31 },
                    { month: 'April', days: 30 },
                    { month: 'May', days: 31 },
                    { month: 'June', days: 30 },
                    { month: 'July', days: 31 },
                    { month: 'August', days: 31 },
                    { month: 'September', days: 30 },
                    { month: 'October', days: 31 },
                    { month: 'November', days: 30 },
                    { month: 'December', days: 31 },
                ],
                daysWeek: [
                    this.$t('app.sunday'),
                    this.$t('app.monday'),
                    this.$t('app.tuesday'),
                    this.$t('app.wedensday'),
                    this.$t('app.thursday'),
                    this.$t('app.friday'),
                    this.$t('app.saturaday')
                ],

            },
        }
    },
    mounted() {},
    created(){
        // AccessToken & Role
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }
        //console.log(new Date().getMonth()+1);
        //console.log(new Date().toLocaleString('default', { month: 'long' }));
    },
    methods: {
        //
        changeMonth() {
            this.row.daysInMonth = new Date(this.row.year, this.row.month, 0).getDate();
        },
        fetchDay(i) {
            console.log(i)
            var res = '';
            return res;

            // if(this.fetchAbsences(i)) {
            //     return 'absences';
            // }

            // if(this.fetchVacations(i)) {
            //     return 'vacation';
            // }

            // if(this.fetchRewards(i)) {
            //     return 'reward';
            // }

            // console.log('...'+i+'/'+this.row.month+'/'+this.row.year)
            // return '';
            // if(i == 2) {
            //     return {'key': 1, 'value' : this.$t('app.reward')};
            // } else if (i == 3 || i == 5 || i == 28) {
            //     return {'key' : 2, 'value' : this.$t('app.absent')};
            // } else if (i == 16) {
            //     return {'key' : 3, 'value' : this.$t('app.vacation')};
            // } else {
            //     return '';
            // }
        },

        fetchAbsences(i){
            let date = i+'/'+this.row.month+'/'+this.row.year;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/absences/check/date',
                method: 'GET',
                data: {},
                params: {
                    employee_id: this.$route.params.id,
                    date: date
                }
            }
            this.axios(options)
            .then(res => {
                if(res.data.status) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch(() => {
                return false;
            })
        },

        fetchVacations(i){
            let date = i+'/'+this.row.month+'/'+this.row.year;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/vacations/check/date',
                method: 'GET',
                data: {},
                params: {
                    employee_id: this.$route.params.id,
                    date: date
                }
            }
            this.axios(options)
            .then(res => {
                if(res.data.status) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch(() => {
                return false;
            })
        },

        fetchRewards(i){
            let date = i+'/'+this.row.month+'/'+this.row.year;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/rewards/check/date',
                method: 'GET',
                data: {},
                params: {
                    employee_id: this.$route.params.id,
                    date: date
                }
            }
            this.axios(options)
            .then(res => {
                if(res.data.status) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch(() => {
                return false;
            })
        },
    }
}
</script>

<style scoped="">
    .table tr th { height: 50px !important }
    .table tr td { height: 50px !important }
    .div-disabled { background: #dddcdc; border:1px solid white; }
</style>
